
import { withRouter } from '@ipc/ipc-core';
import Component from './component';

export default withRouter(Component);
